const DB = "trt-public-form";
const STORE = "files";

const open = () => new Promise((res, rej) => {
  const r = indexedDB.open(DB, 1);
  r.onupgradeneeded = () => r.result.createObjectStore(STORE);
  r.onsuccess = () => res(r.result);
  r.onerror = () => rej(r.error);
});

const tx = async (mode, fn) => {
  try {
    const db = await open();
    return await new Promise((res, rej) => {
      const t = db.transaction(STORE, mode);
      const req = fn(t.objectStore(STORE));
      t.oncomplete = () => res(req && req.result);
      t.onerror = () => rej(t.error);
    });
  } catch { return undefined; }
};

export const saveFile = (ns, key, file) => tx("readwrite", (s) => s.put({ blob: file, name: file.name, type: file.type }, `${ns}:${key}`));
export const removeFile = (ns, key) => tx("readwrite", (s) => s.delete(`${ns}:${key}`));
export const loadFiles = async (ns) => {
  const out = {};
  const keys = (await tx("readonly", (s) => s.getAllKeys())) || [];
  for (const k of keys) {
    if (!String(k).startsWith(`${ns}:`)) continue;
    const v = await tx("readonly", (s) => s.get(k));
    if (v?.blob) out[String(k).slice(ns.length + 1)] = new File([v.blob], v.name || "foto.jpg", { type: v.type || v.blob.type });
  }
  return out;
};
export const clearFiles = async (ns) => {
  const keys = (await tx("readonly", (s) => s.getAllKeys())) || [];
  for (const k of keys) if (String(k).startsWith(`${ns}:`)) await tx("readwrite", (s) => s.delete(k));
};
